import styles from "./ConfirmationModal.module.scss";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
  isLoading: boolean;
}

export function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  message,
  isLoading,
}: ConfirmationModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.overlay} onClick={isLoading ? undefined : onClose}>
      <div className={styles.modalWrapper} onClick={(e) => e.stopPropagation()}>
        <p className={styles.message}>{message}</p>
        <div className={styles.buttons}>
          <button
            onClick={onConfirm}
            className={`${styles.button} ${styles.confirmButton}`}
            disabled={isLoading}
          >
            {isLoading ? <div className={styles.spinner} /> : "Да"}
          </button>
          <button
            onClick={onClose}
            className={`${styles.button} ${styles.cancelButton}`}
            disabled={isLoading}
          >
            Нет
          </button>
        </div>
      </div>
    </div>
  );
}
